<template>
  <v-flex class="pa-0 main fill-height" fluid>
    <v-layout>
      <v-flex md12>
        <div>
          <v-layout row wrap justify-end>

            <v-flex md2>
              <NavDrawer />
            </v-flex>

            <v-flex md9>
              <Header :name="'Plant Device Configuration'" />
              <v-divider></v-divider>
              <v-card class="ma-4">
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs12 sm3 md2 pa-2>
                      <v-text-field disabled v-model="cust_id" label="Customer ID" outline></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md10 pa-2>
                      <v-text-field disabled v-model="cust_name" label="Customer Name" outline></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 sm3 md2 pa-2>
                      <v-text-field disabled v-model="plantId" label="Plant ID" outline></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md10 pa-2>
                      <v-text-field disabled v-model="plant_name" label="Plant Name" outline></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 lg4 pa-1>
                      <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                        lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field outline v-model="commission_date" label="Commission Date" hint="YYYY/MM/DD format"
                            persistent-hint prepend-icon="event" v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="commission_date" no-title @input="menu1 = false" :max="expiry_date && renew_date">
                        </v-date-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 lg4 pa-1>
                      <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                        lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field outline v-model="expiry_date" label="Expiry Date" hint="YYYY/MM/DD format"
                            persistent-hint prepend-icon="event" v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="expiry_date" no-title @input="menu2 = false" :min="renew_date && commission_date"></v-date-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 lg4 pa-1>
                      <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" :nudge-right="40" lazy
                        transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field outline v-model="renew_date" label="Renew Date"
                            hint="YYYY/MM/DD format" persistent-hint prepend-icon="event" readonly v-on="on">
                          </v-text-field>
                        </template>
                        <v-date-picker v-model="renew_date" no-title @input="menu3 = false" :min="commission_date" :max="expiry_date"></v-date-picker>
                      </v-menu>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="save">save</v-btn>
                <v-btn color="error" @click="reset">Reset</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import NavDrawer from '@/components/common/NavDrawer.vue';
import Header from '@/components/common/ModularComponent/Header.vue';
import plantDevice from '@/services/plantDevice'

import {
  mapGetters,
  mapMutations
} from 'vuex';

export default {
  components: {
    Header,
    NavDrawer
  },
  data() {
    return {
      plantId:'',
      cust_id: '',
      cust_name: '',
      plant_name: '',
      commission_date: '',
      resetComission_date : '',
      expiry_date: '',
      resetExpiry_date: '',
      renew_date: '',
      resetRenew_date: '',
      menu1: false,
      menu2: false,
      menu3: false
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId']),
    computedDateFormatted() {
      return this.formatDate(this.date)
    }
  },
  async mounted() {
    await this.getPlantDetail()
  },
  methods: {
    ...mapMutations(['SET_SHOW_SNACKBAR', 'SET_SNACKBAR_CONTENT']),
    save() {
      let param = {}
      param['plantId'] = this.getSelectedPlantId
      param['cust_id'] = this.cust_id
      param['plant_name'] = this.plant_name
      param['cust_name'] = this.cust_name
      param['expiry_date'] = this.expiry_date
      param['commission_date'] = this.commission_date
      param['renew_date'] = this.renew_date
      this.resetComission_date = this.commission_date
      this.resetExpiry_date = this.expiry_date
      this.resetRenew_date = this.renew_date
      plantDevice.updatePlantDetail(param).then(res => {
        console.log(res, 'done')
        if(res.status == 200) {
          let payload = {
            icon: 'success',
            message: 'Updated Successfully'
          }
          this.SET_SNACKBAR_CONTENT(payload)
          this.SET_SHOW_SNACKBAR(true)
        } else if(res.status == 500) {
          let payload = {
            icon: 'error',
            message: 'Updation Failed'
          }
          this.SET_SNACKBAR_CONTENT(payload)
          this.SET_SHOW_SNACKBAR(true)
        }
      }).catch(err => console.log(err, 'ERROR'))
    },
    reset() {
      this.commission_date = this.resetComission_date
      this.expiry_date = this.resetExpiry_date
      this.renew_date = this.resetRenew_date
    },
    getPlantDetail() {
      plantDevice.getPlantDetail(this.getSelectedPlantId).then(res => {
        this.plantId = this.getSelectedPlantId
        this.cust_id = res.data[0]['cust_id']
        this.cust_name = res.data[0]['cust_name']
        this.plant_name = res.data[0]['plant_name']
        this.commission_date = res.data[0]['commission_date']
        this.resetComission_date = res.data[0]['commission_date']
        this.expiry_date = res.data[0]['expiry_date']
        this.resetExpiry_date = res.data[0]['expiry_date']
        this.renew_date = res.data[0]['renew_date']
        this.resetRenew_date = res.data[0]['renew_date']
      }).catch(err => console.log(err, 'ERROR'))
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  },
  watch: {
    getSelectedPlantId() {
      this.getPlantDetail()
    }
  }
}
</script>